import fetch from 'isomorphic-unfetch'
import { logException } from 'lib/errors'

class AppVersionHandler {
    currentContainerTag

    fetchVersionAndReloadIfChanged = async () => {
        const fetchUrl = window.location.protocol + '//' + window.location.hostname + '/health'
        // use /health to fetch container tag that is unique for each deployment/release
        return fetch(fetchUrl)
            .then(response => {
                if (response && response.text) {
                    return this.readHealthResponse(response)
                } else {
                    logException(new Error('Invalid health response:', { cause: response }))
                }

                return false
            })
            .catch(e => logException(e))
    }

    readHealthResponse = async (response) => {
        return response.text()
            .then(responseContent => {
                // try to parse the container tag from the response body
                // The body should look something like this:
                /**
                 * Container tag: 6a3ef5332fecee8d4f53fb7d9c3bb8b572d4dd8d
                 * OK (0.055889844894409 s)
                 */
                const re = /Container tag: (.*?)[\n]/
                const parts = responseContent.match(re)
                if (!parts || parts.length !== 2 || !parts[1]) {
                    logException(new Error('Invalid version: ' + responseContent))
                    return
                }

                const containerTag = parts[1] // tag in form '6a3ef5332fecee8d4f53fb7d9c3bb8b572d4dd8d'
                if (this.currentContainerTag && containerTag !== this.currentContainerTag) {
                    this.reloadApp()
                    return true
                }

                this.currentContainerTag = containerTag

                return false
            })
            .catch(e => logException(e))
    }

    reloadApp () {
        console.log('Load new application version...')
        window.location.reload()
    }
}

export default AppVersionHandler
